var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwoPeopleBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_16873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.15 8.25C12.116 8.25 12.893 7.13 12.893 5.75C12.893 4.37 12.116 3.25 11.15 3.25C10.184 3.25 9.4 4.37 9.4 5.75C9.4 7.13 10.184 8.25 11.15 8.25ZM5.9 7.25C7.062 7.25 7.993 5.91 7.993 4.25C7.993 2.59 7.062 1.25 5.9 1.25C4.738 1.25 3.8 2.59 3.8 4.25C3.8 5.91 4.738 7.25 5.9 7.25ZM11.15 10.25C9.869 10.25 7.3 11.17 7.3 13V14.25C7.3 14.8 7.615 15.25 8 15.25H14.3C14.685 15.25 15 14.8 15 14.25V13C15 11.17 12.431 10.25 11.15 10.25ZM5.9 9.25C4.269 9.25 1 10.42 1 12.75V14.25C1 14.8 1.315 15.25 1.7 15.25H5.9V13C5.9 12.15 6.131 10.66 7.559 9.53C6.95 9.35 6.362 9.25 5.9 9.25Z",
    fill: "#0B0C0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_16873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwoPeopleBlack);
export default __webpack_public_path__ + "static/media/icon-two-people-black.cbc6bde0cbd9cb7bb0c5b0caeb3031a2.svg";
export { ForwardRef as ReactComponent };